import { createContext } from 'react'

export const ContactPointsContext = createContext()
